import { Link } from "@/i18n/navigation";

export const Logo = () => (
  <Link href="/">
    <svg
      id="logo-7"
      width="124"
      height="32"
      viewBox="0 0 124 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <image href="/logo siantano.png" x="0" y="0" width="124" height="32" />
    </svg>
  </Link>
);
